import Config from './localenv.json';
export default Config